import { render, staticRenderFns } from "./updateField.vue?vue&type=template&id=49b3947f"
import script from "./updateField.vue?vue&type=script&lang=js"
export * from "./updateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports